import { useContext } from 'react';
import { buildConfigContext } from './build-config-context';

function useBuildConfig() {
  const buildConfig = useContext(buildConfigContext);
  /* istanbul ignore if */
  if (!buildConfig) {
    throw new Error(
      'buildConfigContext value is undefined. Make sure you use the BuildConfigProvider before using the context.'
    );
  }
  return buildConfig;
}

export function useBuildVars() {
  return useBuildConfig().vars;
}
